<template>
  <div class="userface">
    <div class="container text-left mt-3">
      <FormSelector :selectedTypeName="selectedTypeName" />
      <UserAddForm
        :statusObj="statusObj"
        :errorObj="errorObj"
        @emitStatusMessage="emitStatusMessage"
        @emitErrorMessage="emitErrorMessage"
      />
      <UserEditForm
        :statusObj="statusObj"
        :errorObj="errorObj"
        @emitStatusMessage="emitStatusMessage"
        @emitErrorMessage="emitErrorMessage"
      />
      <UserViewForm
        :statusObj="statusObj"
        :errorObj="errorObj"
        @emitStatusMessage="emitStatusMessage"
        @emitErrorMessage="emitErrorMessage"
      />
    </div>
    <div class="container">
      <div class="row justify-content-center">
        <div
          v-if="errorObj.message"
          class="col-12 alert alert-danger text-center px-3"
        >
          {{ errorObj.message }}
          <div class="text-center mt-2">
            <button
              type="button"
              class="btn btn-danger"
              v-on:click="closeError()"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container text-left">
      <p>TODO: Implement capture result display here</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import FormSelector from "@/components/blueberry/FormSelector";
import UserAddForm from "@/components/blueberry/UserAddForm";
import UserEditForm from "@/components/blueberry/UserEditForm";
import UserViewForm from "@/components/blueberry/UserViewForm";

export default {
  name: "olabuser",
  data() {
    return {
      selectedType: "user",
      selectedTypeName: "User"
    };
  },
  components: {
    FormSelector,
    UserAddForm,
    UserEditForm,
    UserViewForm
  },
  props: ["statusObj", "errorObj"],
  emits: ["setStatusMessage", "setErrorMessage"],
  mounted() {
    console.log("User mounted ...");
    // Reset status and error
    this.emitStatusMessage(null, false);
    this.emitErrorMessage(null);
  },
  methods: {
    emitStatusMessage(statusMsg, statusProgress) {
      this.$emit("setStatusMessage", statusMsg, statusProgress);
    },
    emitErrorMessage(errMsg) {
      this.$emit("setErrorMessage", errMsg);
    },
    closeStatus() {
      // console.log("Close Status Alert ...");
      this.emitStatusMessage(null, false);
    },
    closeError() {
      // console.log("Close Error Alert ...");
      this.emitErrorMessage(null);
    }
  }
};
</script>

<style scoped>
.userface {
  padding: 50px 0;
  background-color: #fdf2e9;
}
</style>
